import { UNITS } from "../../../lib/units";

/** The footer's unit drop-down, styled to sit in the bar (a real select underneath). */
export function UnitPicker({ value, onChange }: { value: number; onChange: (id: number) => void }) {
  return (
    <label className="UnitPicker" title="Display unit">
      <select aria-label="Display unit" value={value} onChange={(e) => onChange(Number(e.target.value))}>
        {UNITS.map((u) => (
          <option key={u.id} value={u.id}>
            {u.name}
          </option>
        ))}
      </select>
      <span className="chevron" aria-hidden="true" />
    </label>
  );
}
